import 'owl.carousel2/dist/assets/owl.carousel.css';
import 'owl.carousel2/dist/assets/owl.theme.default.css';
import $ from 'jquery';
import 'owl.carousel2/dist/owl.carousel';

// import './../../styles/shared/modules/main_news.css'

((($) => {

    let _mainSlider = $('.js-main-news-slider');
    if (_mainSlider.length) {
        _mainSlider.owlCarousel({
            autoplay: true,
            autoplayTimeout: 5000,
            items: 2.3,
            rtl: true,
            nav: true,
            navText: ['<i class="icon-keyboard_arrow_right"></i>', '<i class="icon-keyboard_arrow_left"></i>'],
            loop: true,
            margin: 5,
            responsive: {
                0: {
                    items: 1.3,
                },
                1000: {
                    items: 2.3,
                }
            },
            onInitialized: function () {
                // let _placeholderId = _mainSlider.data('placeholder');
                // if (typeof _placeholderId !== 'undefined') {
                //     let _placeholder = $(`#${_placeholderId}`);
                //     if (_placeholder.length) {
                //         _mainSlider.show('fast', function () {
                //             _placeholder.remove();
                //         });
                //     }
                // }
            },
        });
    }

    let _mainSliderV2 = $('.js-main-news-v2-slider');
    if (_mainSliderV2.length) {
        _mainSliderV2.owlCarousel({
            autoplay: true,
            autoplayTimeout: 5000,
            items: 1,
            rtl: true,
            nav: true,
            navText: ['<i class="icon-keyboard_arrow_right"></i>', '<i class="icon-keyboard_arrow_left"></i>'],
            loop: true,
            margin: 0,
            dots: true,
            onInitialized: function () {
                let _placeholderClass = _mainSliderV2.data('placeholder');
                if (typeof _placeholderClass !== 'undefined') {
                    let _placeholder = _mainSliderV2.parent().find(`.${_placeholderClass}`);
                    if (_placeholder.length) {
                        _mainSliderV2.show('fast', function () {
                            _placeholder.remove();
                        });
                    }
                }
            },
        });
    }

    const fetchAjax = (block) => {
        let _block = $(block);
        if (typeof _block.data('fetching') !== 'undefined' && _block.data('fetching') === '1') {
            return false;
        }
        let _url = _block.data('url');
        if (typeof _url === 'undefined' || !_url.length) {
            _block.remove();
            return false;
        }
        let _hasMore = _block.data('has-more');
        if (typeof _hasMore !== 'boolean' || !_hasMore) {
            _block.remove();
            return false;
        }
        let _page = _block.data('page');
        if (typeof _page === 'undefined' || isNaN(_page)) {
            _page = 1;
        }
        _page *= 1;

        let _ids = '';
        if (typeof window.loadedItemsIds !== 'undefined') {
            _ids = window.loadedItemsIds;
        }
        _block.data('fetching', '1');

        $.ajax({
            url: _url,
            contentType: 'JSON',
            // headers: {
            //     'Content-Type': 'application/json',
            // },
            method: 'GET',
            data: {
                // json: 1,
                page: _page,
                registry_ids: _ids,
            },
            success: function (_response) {
                if (typeof _response !== 'undefined' && _response.toString().length) {
                    let _html = $(_response);
                    let _parent = _block.parent();
                    _block.replaceWith(_html);
                    _parent.find('.js-infinite-scroll').each(function () {
                        _initInfiniteScroll(this);
                    });
                }
                // _block.attr('data-fetching', '0');
            },
            error: function () {
                _block.remove();
            },
            complete: function () {
            }
        });
    };

    const onElementVisible = (entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                fetchAjax(entry.target);
            }
        });
    };

    const _initInfiniteScroll = (_element) => {
        const observer = new IntersectionObserver(onElementVisible, {
            root: null,
            threshold: 0.3
        });
        observer.observe(_element);
    }

    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return false;
    };

    let _infiniteLoader = $('.js-infinite-scroll');
    if (_infiniteLoader.length) {
        _infiniteLoader.each(function () {
            _initInfiniteScroll(this);
            // var _test = getUrlParameter('test-demo');
            // if (_test && _test == '1') {
            //     _initInfiniteScroll(this);
            // } else {
            //     $(this).remove();
            // }
        });
    }


})(jQuery));
